import { Card } from "@/components/ui/card";
import { Wrench, Palette, Heart, Sparkles, CircleDot, Circle } from "lucide-react";

export const AboutSection = () => {
  const values = [
    {
      icon: Wrench,
      title: "Jakość",
      description: "Używamy tylko najlepszych materiałów i technik. Każdy detal ma znaczenie."
    },
    {
      icon: Palette,
      title: "Kreatywność", 
      description: "Nie boimy się nietypowych projektów. Każda wizja zasługuje na realizację."
    },
    {
      icon: Heart,
      title: "Pasja",
      description: "Jesteśmy kolarzami, a każdy projekt traktujemy jak własny rower."
    }
  ];

  return (
    <section className="relative py-24 px-6 bg-gradient-to-b from-background to-muted/20 overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-1/4 -left-8 w-16 h-16 opacity-20 text-primary">
        <CircleDot className="w-full h-full animate-pulse" />
      </div>
      <div className="absolute bottom-1/4 -right-8 w-24 h-24 opacity-15 text-accent">
        <Circle className="w-full h-full animate-pulse" />
      </div>
      <div className="absolute top-1/3 right-10 w-8 h-8 opacity-20 text-foreground">
        <Sparkles className="w-full h-full animate-float" />
      </div>
      
      <div className="max-w-6xl mx-auto relative z-10">
        <div className="text-center mb-16 relative">
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 w-24 h-1 bg-gradient-to-r from-transparent via-primary to-transparent rounded-full"></div>
          <h2 className="font-montserrat font-bold text-4xl md:text-5xl mb-6">
            O <span className="text-gradient-primary">Pimp my Bike</span>
          </h2>
          <div className="w-16 h-1 bg-gradient-to-r from-transparent via-accent to-transparent mx-auto my-6 rounded-full"></div>
          <div className="max-w-4xl mx-auto">
            <p className="text-xl text-muted-foreground mb-8 font-montserrat leading-relaxed max-w-3xl mx-auto">
              Specjalizujemy się w profesjonalnym tuningu i customizacji rowerów. 
              Klienci wysyłają swoje rowery kurierem, a my przekształcamy je w unikatowe dzieła sztuki.
            </p>
            <div className="relative inline-block">
              <p className="relative z-10 text-lg text-foreground font-montserrat leading-relaxed max-w-3xl mx-auto bg-card/50 backdrop-blur-sm p-6 rounded-lg border border-border/20 shadow-sm">
                Nasze usługi obejmują zmianę kolorów i malowanie ram, nakładanie powłok ochronnych, 
                wymianę i personalizację komponentów oraz dodawanie niestandardowego wyposażenia.
              </p>
              <div className="absolute -inset-1 bg-gradient-to-r from-primary/20 to-accent/20 rounded-lg blur opacity-30"></div>
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {values.map((value, index) => (
            <Card key={index} className="p-8 bg-card/50 backdrop-blur-sm border-accent/20 interactive-scale">
              <div className="text-center">
                <div className="w-16 h-16 mx-auto mb-6 bg-gradient-primary rounded-2xl flex items-center justify-center neon-glow-cyan">
                  <value.icon className="w-8 h-8 text-primary-foreground" />
                </div>
                <h3 className="font-montserrat font-bold text-2xl mb-4 text-gradient-primary">
                  {value.title}
                </h3>
                <p className="text-muted-foreground font-inter leading-relaxed">
                  {value.description}
                </p>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};